import { render, staticRenderFns } from "./CariReport.vue?vue&type=template&id=4666d980&scoped=true"
import script from "./CariReport.vue?vue&type=script&lang=js"
export * from "./CariReport.vue?vue&type=script&lang=js"
import style0 from "./CariReport.vue?vue&type=style&index=0&id=4666d980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4666d980",
  null
  
)

export default component.exports